import React from "react"
import { graphql } from "gatsby"
import { Meta } from "@outdoormap/gatsby-plugin-brand-sites"

import Layout from "../components/layout"
import Post from "../components/post"

export default function ArticlesPostTemplate({
  data: { config, translations, article, latest },
}) {
  return (
    <Layout>
      <Post
        data={article}
        other={latest}
        otherHeading={config.pages.articles.title}
        otherCta={translations.global.seeAll}
        otherCtaUrl={`/${config.pages.articles.slug}`}
      />
    </Layout>
  )
}

export const Head = ({ data: { article } }) => {
  return (
    <Meta
      data={{
        title: article.title,
        socialImage: article.images[0]?.images.fallback.src,
      }}
    />
  )
}

export const pageQuery = graphql`
  query ($id: String!) {
    translations: translationsJson {
      global {
        seeAll
      }
    }

    config: configJson {
      pages {
        articles {
          title
          slug
        }
      }
    }

    article: articlesJson(id: { eq: $id }) {
      title
      body
      images {
        ...NKimageFragment
      }
      sites {
        ...SitesCardFragment
      }
      files {
        id
        url
        text
      }
      links {
        id
        url
        text
      }
    }

    latest: allArticlesJson(
      filter: { id: { ne: $id } }
      sort: { publish_at: DESC }
      limit: 6
    ) {
      nodes {
        ...ArticlesCardFragment
      }
    }
  }
`
